<h2 class="c:blue-700 m-0:b">{{ title() }}</h2>
<p>Versicherungsnummer {{ contract()?.insuranceNumber }}</p>
